import { render } from "./PermissionConfirm.vue?vue&type=template&id=43054f7b&scoped=true&ts=true"
import script from "./PermissionConfirm.vue?vue&type=script&lang=ts"
export * from "./PermissionConfirm.vue?vue&type=script&lang=ts"

import "./PermissionConfirm.vue?vue&type=style&index=0&id=43054f7b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src613357358/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43054f7b"]])

export default __exports__